<template>
  <div class="projects-detail-meta mt-12 lg:-mt-32">
    <div class="grid grid-cols-12 gap-4 lg:gap-12 xl:gap-24">
      <div class="col-span-12 lg:col-span-6 flex items-end">
        <div class="flex flex-col w-full">
          <kf-breadcrumb
            v-if="breadcrumbItems.length"
            :breadcrumb-items="breadcrumbItems"
          />
          <h2 v-if="name">
            {{ name }}
          </h2>
          <div class="line-clamp-[8]">
            <slot />
          </div>
        </div>
      </div>
      <div class="col-span-12 lg:col-span-6 flex items-end">
        <div class="bg-white p-4 lg:p-8 rounded-smd shadow-md w-full">
          <div class="flex flex-row items-center gap-2">
            <img
              v-if="icon"
              :src="icon"
              alt=""
              class="w-4 h-4"
            >
            <p
              v-if="type"
              class="mb-0"
            >
              {{ type }}
            </p>
          </div>
          <h2
            v-if="name"
            class="mb-4"
          >
            {{ name }}
          </h2>
          <p v-if="address || city">
            {{ address }} <span v-if="address && city">-</span> {{ city }}
          </p>
          <kf-map-widget
            :map-widget-location-name="name"
            :map-widget-lat="geoLat"
            :map-widget-lon="geoLng"
            map-widget-size="430x250"
            :map-widget-zoom="16"
            class="mb-5"
          />
          <p
            v-if="description"
          >
            <kf-rich-text>
              <!-- eslint-disable-next-line vue/no-v-html -->
              <div v-html="description" />
            </kf-rich-text>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import KfRichText from '@/components/base/rich-text/RichText.vue';
import KfMapWidget from '@/components/map-widget/MapWidget.vue';


export default {
  name: 'KfProjectsDetailMeta',
  components: {
    KfMapWidget,
    KfRichText,
    KfBreadcrumb: () => import(/* webpackChunkName: "main"*/ '@/components/breadcrumb/Breadcrumb.vue'),
  },
  props: {
    name: {
      type: String,
      default: '',
    },
    bodyText: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    address: {
      type: String,
      default: '',
    },
    postalCode: {
      type: String,
      default: '',
    },
    city: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    image: {
      type: String,
      default: '',
    },
    geoLng: {
      type: String,
      default: '',
    },
    geoLat: {
      type: String,
      default: '',
    },
    breadcrumbItems: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      searchQuery: '',
      filteredSuggestions: [],
      showSuggestions: false,
    };
  },
};
</script>

<style>
.projects-detail-meta {
  grid-row: span 1;

  .map-widget {
    img {
      @apply w-full object-cover object-center max-h-[250px];
    }
  }

  .breadcrumb {
    @apply py-0 mb-5;
  }
}

.project-detail-carousel {
  .carousel {
    .glide__track {
      @apply pl-0;
    }
  }
}

</style>
